// Splits a free-text recipient field into trimmed, de-duplicated, non-empty
// entries. Splits on commas/semicolons/newlines only (not spaces) so a phone
// number with internal spaces — "(204) 555 1234" — stays one entry.
export const parseRecipients = (raw: string): string[] => {
  if (!raw) return [];
  const parts = raw.split(/[\n,;]+/).map((s) => s.trim()).filter(Boolean);
  return Array.from(new Set(parts));
};
